var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeartFull(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 53,
    viewBox: "0 0 53 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2400_4310)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2400_4310)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.4058 13.7048C10.3936 11.7176 13.0893 10.6013 15.9 10.6013C18.7107 10.6013 21.4064 11.7176 23.3942 13.7048L26.5 16.808L29.6058 13.7048C30.5836 12.6924 31.7533 11.8849 33.0465 11.3293C34.3397 10.7738 35.7307 10.4814 37.1381 10.4692C38.5456 10.4569 39.9414 10.7251 41.2441 11.2581C42.5468 11.7911 43.7303 12.5782 44.7256 13.5734C45.7208 14.5687 46.5079 15.7522 47.0409 17.0549C47.5739 18.3576 47.8421 19.7534 47.8298 21.1609C47.8176 22.5683 47.5252 23.9593 46.9697 25.2525C46.4141 26.5457 45.6066 27.7154 44.5942 28.6932L26.5 46.7901L8.4058 28.6932C6.4186 26.7054 5.30226 24.0097 5.30226 21.199C5.30226 18.3883 6.4186 15.6926 8.4058 13.7048V13.7048Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.4058 13.7048C10.3936 11.7176 13.0893 10.6013 15.9 10.6013C18.7107 10.6013 21.4064 11.7176 23.3942 13.7048L26.5 16.808L29.6058 13.7048C30.5836 12.6924 31.7533 11.8849 33.0465 11.3293C34.3397 10.7738 35.7307 10.4814 37.1381 10.4692C38.5456 10.4569 39.9414 10.7251 41.2441 11.2581C42.5468 11.7911 43.7303 12.5782 44.7256 13.5734C45.7208 14.5687 46.5079 15.7522 47.0409 17.0549C47.5739 18.3576 47.8421 19.7534 47.8298 21.1609C47.8176 22.5683 47.5252 23.9593 46.9697 25.2525C46.4141 26.5457 45.6066 27.7154 44.5942 28.6932L26.5 46.7901L8.4058 28.6932C6.4186 26.7054 5.30226 24.0097 5.30226 21.199C5.30226 18.3883 6.4186 15.6926 8.4058 13.7048V13.7048Z",
    stroke: "black",
    strokeWidth: 3,
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2400_4310",
    x: -0.197739,
    y: 8.96875,
    width: 53.528,
    height: 47.3203,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2400_4310"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2400_4310",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2400_4310"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 53,
    height: 53,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartFull);
export default __webpack_public_path__ + "static/media/heart_full.f53b94ed0ce6ebe45fe92416c97a36a0.svg";
export { ForwardRef as ReactComponent };